export default "__VITE_IMAGE_ASSET__b7b0a3ba__";